import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showLimitDialog: false,
    showExperience: true
  },
  mutations: {
    changeLimitDialog (state, show) {
      state.showLimitDialog = show
    },
    closeExperience (state, show) {
      state.showExperience = show
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js